import React, { useEffect, useState } from 'react';
import { IComboBoxOption } from '@fluentui/react';
import { IPFieldProps } from '../../types/field-props';
import CComboBox from '../types/CComboBox';
import { XComboBox, XTextField } from '@ioip/core/lib';

export const UXComboBox = (props: IPFieldProps<CComboBox>): JSX.Element => {

    const [ state, setState ] = useState<{ options: IComboBoxOption[]; isLoading: boolean; }>({ options: [], isLoading: true })
    const field = props.field;
    const label = field.label;
    const disabled = field.readonly || field.disabled;
    const required = field.required;

    useEffect(() => {
        if (field.datasource != null)
            setState({ isLoading: false, options: field.asFluentUI() });
        else
            setState({ isLoading: false, options: [] });
    }, []);

    if (state.isLoading)
        return <XTextField readonly label={label || ''} value='Loading combobox...' />

    if (props.field.form.readonly) {
        const text = state.options.find(o => o.key === props.field.value)?.text;
        return <XTextField
            label={label || ''}
            required={required || false}
            disabled={true}
            readonly={true}
            value={text}
            errorMessage={props.field.errorMessage || ''}
        />
    }

    return <XComboBox
        value={props.field.value}
        label={label || ''}
        disabled={disabled}
        options={state.options}
        onChange={value => props.field.value = value}
        required={required || false}
        errorMessage={props.field.errorMessage || ''}
    />
}